import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import Card from "@irati/ui/src/Layout/Card"
import Button from "@irati/ui/src/Button"

export const EmptyRows = styled(Card)`
  border: 2px dashed ${({theme}) => theme.colors.greys.mediumLight};
  box-shadow: none;
  padding: 90px;
`

export const RowButtonWrapper = styled.div`
  text-align: center;
`

export const DeleteRowButton = styled(Button)`
  margin-right: ${padding.tiny};
`
